export default __webpack_public_path__ + "static/media/best-thing-ever.d0a71774.gif";